<template>
  <div class="whaty-chart-wrapper" :style="wrapperStyle">
    <div :id="id" class="whaty-chart" :style="chartStyle"></div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import util from '../../libs/util'

  const uuidv1 = require('uuid/v1')
  export default {
    name: 'whaty-chart',
    props: {
      chartCode: {
        type: String,
        default: '',
        required: true
      },
      chartData: { // 数据
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        id: '',
        basicConfig: {},
        chartConfig: {},
        dataUrl: '',
        dataParams: {}
      }
    },
    computed: {
      wrapperStyle() {
        return this.basicConfig.wrapperStyle || {}
      },
      chartStyle() {
        return this.basicConfig.chartStyle || {}
      }
    },
    created() {
      this.initId()
    },
    mounted() {
      this.loadChartConfig()
    },
    methods: {
      initId() {
        this.id = uuidv1()
      },
      loadChartConfig() {
        if (!this.chartCode) {
          return
        }
        let params = {
          chartCode: this.chartCode
        }
        util.ajax.post('/core/chart/config', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            let config = res.data.data
            this.basicConfig = config.basicConfig ? config.basicConfig : {}
            this.chartConfig = config.chartConfig ? config.chartConfig : {}
            this.dataUrl = config.dataUrl
            this.dataParams = config.dataParams ? config.dataParams : {}
            if (this.chartConfig) {
              // 等后端配置的样式生效以后再初始化echarts
              this.$nextTick(_ => {
                this.chart = echarts.init(document.getElementById(this.id))
                this.chart.setOption(this.chartConfig)
                this.loadChartData()
              })
            } else {
              this.chart.hideLoading()
            }
          } else {
            this.chart.hideLoading()
            this.$notify.error({title: '错误', message: '加载图表配置失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.chart.hideLoading()
          this.$notify.error({title: '错误', message: '加载图表配置失败'})
          console.error(err)
        })
      },
      loadChartData() {
        if (this.chartConfig && this.dataUrl) { // 从远程加载数据
          this.chart.showLoading()
          let params = {
            chartCode: this.chartCode,
            ...this.dataParams
          }
          util.ajax.post(this.dataUrl, {params}).then((res) => {
            this.chart.hideLoading()
            if (res.data.meta.errCode === 0 && res.data.data) {
              this.chart.setOption({
                dataset: {
                  sourceHeader: false,
                  source: res.data.data
                }
              })
            } else {
              this.$notify.error({title: '错误', message: '加载图表数据失败：' + res.data.meta.errMsg})
            }
          }).catch((err) => {
            this.chart.hideLoading()
            this.$notify.error({title: '错误', message: '加载图表数据失败'})
            console.error(err)
          })
        } else { // 使用本地数据
          this.chart.setOption({
            dataset: {
              sourceHeader: false,
              source: this.chartData
            }
          })
        }
      }
    },
    watch: {
      'chartData': function (newVal) {
        this.chart.setOption({
          dataset: {
            sourceHeader: false,
            source: newVal
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .whaty-chart-wrapper {
    width: 100%;
    height: calc(100% - 20px);
    margin: 10px auto;
    .whaty-chart {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/whaty-charts/whaty-chart.vue